/* global I18N */

import { Controller } from 'stimulus';
import formatPrice from '../helpers/formatPrice';

class CartSummaryController extends Controller {
  connect() {
    this.subTotal = parseFloat(this.data.get('sub-total'));
    this.shippingCosts = parseFloat(this.data.get('shipping-costs'));
    this.couponValue = parseFloat(this.data.get('coupon-value'));
  }

  setShippingCosts(price) {
    this.shippingCosts = price;
    this.recalculate();
  }

  setCouponValue(price) {
    if (this.hasCouponValueTarget) {
      this.couponValue = price;
      this.recalculate();
    }
  }

  recalculate() {
    this.total = this.subTotal + this.shippingCosts - this.couponValue;

    this.totalTarget.innerHTML = formatPrice(this.total);

    if (this.hasShippingCostsTarget) {
      this.shippingCostsTarget.innerHTML = this.shippingCosts
        ? formatPrice(this.shippingCosts)
        : I18N.shippingCostsFree;
    }

    if (this.hasCouponValueTarget) {
      this.couponValueTarget.innerHTML = `– ${this.couponValue}`;
    }
  }
}

CartSummaryController.targets = [
  'shippingCosts',
  'total',
  'couponValue',
];

export default CartSummaryController;
